import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-bold text-sm">51</span>
              </div>
              <span className="text-lg font-bold text-foreground-950">
                吃瓜网51
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              全网最快最全的免费吃瓜平台，每日实时更新网红黑料、明星八卦与今日大瓜。吃瓜群众必备神器！
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#download"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  下载App
                </a>
              </li>
              <li>
                <Link
                  to="/category/today-hot"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  今日大瓜
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center text-primary-500" />
                hello@biomicskin.cn
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-fill w-4 h-4 flex items-center justify-center text-primary-500" />
                吃瓜网51官方
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center text-primary-500 mt-0.5" />
                北京市朝阳区科技园路88号
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 吃瓜网51 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors"
            >
              用户协议
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors"
            >
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}